
export interface AccountItem {
  id: string;
  name: string;
  balance: number;
}

export interface AccountGroup {
  name: string;
  accounts: AccountItem[];
}

export const accountGroups: AccountGroup[] = [
  { name: 'Assets', accounts: [
    { id: '1000', name: 'Cash & Bank', balance: 275000000 },
    { id: '1200', name: 'Investments', balance: 75000000 },
    { id: '1300', name: 'Loans Given', balance: 175000000 },
  ]},
  { name: 'Liabilities', accounts: [
    { id: '2100', name: 'Loans Taken', balance: 150000000 },
    { id: '2110', name: 'Interest Payable', balance: 583333 },
  ]},
  { name: 'Income', accounts: [
    { id: '4100', name: 'Investment Income', balance: 125000 },
    { id: '4200', name: 'Loan Interest Income', balance: 312500 },
  ]},
  { name: 'Expenses', accounts: [
    { id: '6100', name: 'Interest Expense', balance: 583333 },
  ]},
];

// Prepare data for chart
export const chartData = accountGroups.map(group => {
  const total = group.accounts.reduce((sum, account) => sum + account.balance, 0);
  return {
    name: group.name,
    value: total,
  };
});

// Colors for the chart
export const CHART_COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
